import React, { Children } from 'react'

const FormRow = ({ children, cutoff = 'md', perRow = 2 }) => {
  if (!children) return null
  const rows = Children.toArray(children)
  return (
    <div className="row">
      {rows.filter(Boolean).map((child, index) => (
        <div className={`col-${cutoff}-${12 / perRow}`} key={index}>
          {child}
        </div>
      ))}
    </div>
  )
}

export default FormRow
